var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDate = function SvgDate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.749,
    height: 21.999,
    viewBox: "0 0 25.749 21.999",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 2.95,
    transform: "translate(7.251)",
    fill: "none",
    stroke: "#959cf2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 2.95,
    transform: "translate(16.498)",
    fill: "none",
    stroke: "#959cf2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 23.749,
    transform: "translate(0 7.498)",
    fill: "none",
    stroke: "#3953fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.749,
    height: 17.05,
    rx: 4,
    transform: "translate(0 2.949)",
    fill: "none",
    stroke: "#3953fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 2.95,
    transform: "translate(3.67 11.246)",
    fill: "none",
    stroke: "#959cf2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 2.95,
    transform: "translate(3.67 14.996)",
    fill: "none",
    stroke: "#959cf2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 2.95,
    transform: "translate(11.01 14.996)",
    fill: "none",
    stroke: "#959cf2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 2.95,
    transform: "translate(11.01 11.246)",
    fill: "none",
    stroke: "#959cf2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 2.95,
    transform: "translate(17.498 14.996)",
    fill: "none",
    stroke: "#959cf2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.748,
    height: 17.05,
    rx: 4,
    transform: "translate(0 2.949)",
    fill: "none",
    stroke: "#3953fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/date.037acc9e.svg";
export { ForwardRef as ReactComponent };